module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Bold-Alphabetic.41e1de59.woff";